import request from "../../utils/request";
import { Result } from "../../models/general";

export interface DateFormatConfigModel {
  id?: number;
  companyId: number;
  configType: 'default' | 'us' | 'iso' | 'custom';
  customFormats?: string; // JSON string of custom formats
  createdAt?: string;
  updatedAt?: string;
}

export interface DateFormats {
  // Basic date formats
  date: {
    display: string;
    input: string;
    api: string;
    short: string;
    long: string;
  };
  
  // Time formats
  time: {
    display: string;
    input: string;
    short: string;
    long: string;
    ampm: string;
  };
  
  // DateTime formats
  datetime: {
    display: string;
    input: string;
    api: string;
    short: string;
    long: string;
  };
  
  // Specialized formats
  specialized: {
    monthYear: string;
    dayMonth: string;
    weekday: string;
    relativeDays: string;
  };
}

/**
 * Get date format configuration for the current company
 */
export async function getDateFormatConfig(companyId?: number) {
  const response = await request.get<Result<DateFormatConfigModel>>(`Company/GetDateFormatConfig${companyId ? `?companyId=${companyId}` : ''}`);
  return response.data;
}

/**
 * Update date format configuration for the current company
 */
export async function updateDateFormatConfig(config: {
  configType: 'default' | 'us' | 'iso' | 'custom';
  customFormats?: DateFormats;
}, companyId?: number) {
  const payload = {
    configType: config.configType,
    customFormats: config.customFormats ? JSON.stringify(config.customFormats) : null,
    companyId
  };
  
  const response = await request.post<Result<DateFormatConfigModel>>(`Company/UpdateDateFormatConfig${companyId ? `?companyId=${companyId}` : ''}`, payload);
  return response.data;
}

/**
 * Reset date format configuration to default
 */
export async function resetDateFormatConfig(companyId?: number) {
  const response = await request.post<Result<DateFormatConfigModel>>(`Company/ResetDateFormatConfig${companyId ? `?companyId=${companyId}` : ''}`);
  return response.data;
}
